// rc148 — Tipos del módulo WireGuard (servidor wg-byteisp administrado por ByteISP).

export type WgEstadoPeer = "conectado" | "sin_contacto" | "nunca" | "inactivo";

export type WgPeer = {
  id: string;
  descripcion: string;
  router_id: string | null;
  router_nombre: string | null;
  /** El router vinculado YA usa la IP del túnel como ip_address. */
  router_usa_wg: boolean;
  ip_tunel: string;
  public_key: string;
  activo: boolean;
  estado: WgEstadoPeer;
  conectado: boolean;
  last_handshake_at: string | null;
  rx_bytes: number;
  tx_bytes: number;
  endpoint: string | null;
  created_at: string;
};

export type WgAplicacion = {
  aplicado: boolean;
  pendiente: boolean;
  mensaje: string;
};

export type WgPeerMutacionResponse = {
  peer: WgPeer;
  aplicacion: WgAplicacion;
};

export type WgMensajeAplicacion = {
  message: string;
  aplicacion: WgAplicacion;
};

export type WgPeerCreateInput = {
  descripcion: string;
  router_id?: string | null;
};

export type WgPeerUpdateInput = {
  descripcion?: string;
  router_id?: string | null;
  activo?: boolean;
};

export type WgEstado = {
  enabled: boolean;
  interfaz: string;
  server_ip: string;
  listen_port: number;
  endpoint_host: string;
  subnet: string;
  mtu: number;
  keepalive: number;
  server_public_key: string | null;
  public_key_vivo: string | null;
  llave_coincide: boolean | null;
  interfaz_responde: boolean;
  origen_estado: string | null;
  error_estado: string | null;
  simulado: boolean;
  pendiente_aplicar: boolean;
  ultimo_apply: string | null;
  ultimo_apply_at: string | null;
  total: number;
  activos: number;
  conectados: number;
  sin_router: number;
  routers_en_wg: number;
};

export type WgScript = {
  descripcion: string;
  ip_tunel: string;
  script: string;
};

export type PagedWgPeers = {
  items: WgPeer[];
  total: number;
  page: number;
  size: number;
  pages: number;
};

export type RouterWireguardInfo = {
  router_id: string;
  ip_address: string;
  ip_ovpn_respaldo: string | null;
  usando_wireguard: boolean;
  peer: WgPeer | null;
};

export type RouterWireguardPrueba = {
  success: boolean;
  identity: string | null;
  modelo: string | null;
  version_ros: string | null;
  latencia_ms: number | null;
  error: string | null;
};

export type RouterWireguardActivarResponse = {
  ok: boolean;
  mensaje: string;
  ip_anterior: string | null;
  ip_nueva: string | null;
  prueba: RouterWireguardPrueba;
};

// ─── Formato ─────────────────────────────────────────────────────────────
export function formatBytes(n: number): string {
  if (!n) return "0 B";
  const u = ["B", "KB", "MB", "GB", "TB"];
  let i = 0;
  let v = n;
  while (v >= 1024 && i < u.length - 1) { v /= 1024; i += 1; }
  return `${v >= 10 || i === 0 ? v.toFixed(0) : v.toFixed(1)} ${u[i]}`;
}

/** "hace 12 s", "hace 3 min", "hace 2 h", "hace 4 d". */
export function haceCuanto(iso: string | null): string {
  if (!iso) return "—";
  const s = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `hace ${s} s`;
  const m = Math.round(s / 60);
  if (m < 60) return `hace ${m} min`;
  const h = Math.round(m / 60);
  if (h < 48) return `hace ${h} h`;
  return `hace ${Math.round(h / 24)} d`;
}
